import { Routes } from '@angular/router'

import { authGuard } from '@coty/core/auth/auth.guard'
import { redirectIfAuthGuard } from '@coty/core/auth/redirect-if-auth.guard'

import { interactionRoutes } from '@coty/pages/interactions/interactions.routes'

import { ProtocolsComponent } from './pages/protocols/protocols.component'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      {
        path: '',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/interactions/failure-mode/start-failure-mode.component').then(
            (m) => m.StartFailureModeComponent
          )
      },

      {
        path: 'free-chat',
        loadComponent: () =>
          import('./pages/interactions/free-mode/start-free-mode.component').then(
            (m) => m.StartFreeModeComponent
          )
      },

      {
        path: 'interactions',
        canActivate: [authGuard],
        children: interactionRoutes
      },

      {
        path: 'conversations',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/interactions-list/interactions-list.component').then(
            (m) => m.InteractionsListComponent
          )
      },

      // Hidden protocols page - only accessible by manually typing the URL
      {
        path: 'protocols',
        canActivate: [authGuard],
        component: ProtocolsComponent
      },
      {
        path: 'protocols/:id',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/protocols/protocol-detail/protocol-detail.component').then(
            (m) => m.ProtocolDetailComponent
          )
      }
    ]
  },
  {
    path: 'login',
    canActivate: [redirectIfAuthGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent)
  },

  {
    path: '**',
    redirectTo: ''
  }
]
